import { IconButton } from "@mui/material";
import Logo from "../../../assets/logo.svg";
import "./PlayCards.css";
import { HomeRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const PlayNav = () => {
  const navigate = useNavigate();
  const goHome = () => {
    navigate(-1);
  };
  return (
    <nav className="play-mode-nav">
      <img className="logo-image" src={Logo} alt="Assessive Logo" />
      <IconButton onClick={goHome}>
        <HomeRounded fontSize="large" />
      </IconButton>
    </nav>
  );
};

export default PlayNav;
